import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { MESCComponent } from './mesc.component';
import { MescAdministrationComponent } from './administration/administration.component';

// Maintenance
import { MaintenanceComponent } from './administration/maintenance/maintenance.component';
import { PlantProgramComponent } from './administration/maintenance/plant-program/plant-program.component';
import { PlantsComponent } from './administration/maintenance/plants/plants.component';
import { ProgramsComponent } from './administration/maintenance/programs/programs.component';
import { ZonesComponent } from './administration/maintenance/zones/zones.component';
import { SubzoneComponent } from './administration/maintenance/subzone/subzone.component';
import { TitleComponent } from './administration/maintenance/title/title.component';
import { ProgramStyleComponent } from './administration/maintenance/program-style/program-style.component';
import { ModelYearComponent } from './administration/maintenance/model-year/model-year.component';

// Security
import { SecurityComponent } from './administration/security/security.component';
import { UsersComponent } from './administration/security/users/users.component';
import { GroupsComponent } from './administration/security/groups/groups.component';


// Providers
import {
  BaseService,
  CenterService,
  UserService,
  GlobalRegionService,
  RegionService,
  GroupService,
  GroupUserService,
  ModelYearService,
  ModuleService,
  PlantService,
  ProgramService,
  ProgramDetailService,
  ProgramDetailByIdService,
  ToolHandednessService,
  ZoneService,
  SubZoneService,
  ProgramStyleService,
  TitleService,
  PlantProgramService,
  SubZoneTitleService,
  UserProfileService,
  UserLastLoginDateService,
  RoleService
} from './mesc.service';
import { MaintenanceService } from './administration/maintenance/maintenance.service';


@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    MESCComponent,
    MescAdministrationComponent,
    MaintenanceComponent,
    SecurityComponent,
    UsersComponent,
    GroupsComponent,
    PlantsComponent,
    ProgramsComponent,
    ZonesComponent,
    SubzoneComponent,
    TitleComponent,
    PlantProgramComponent,
    ProgramStyleComponent,
    ModelYearComponent,
  ],
  providers: [
    BaseService,
    CenterService,
    UserService,
    GroupService,
    RoleService,
    GlobalRegionService,
    GroupUserService,
    RegionService,
    ModelYearService,
    ModuleService,
    PlantService,
    ProgramService,
    ProgramDetailService,
    ProgramDetailByIdService,
    ToolHandednessService,
    ZoneService,
    SubZoneService,
    SubZoneTitleService,
    ProgramStyleService,
    TitleService,
    PlantProgramService,
    SubZoneTitleService,
    UserProfileService,
    UserLastLoginDateService,
    MaintenanceService,
  ]
})
export class MescModule { }
